import { usePaymentLanguage } from '../../lib/paymentLanguage';
import React from 'react';
import { KGS_BANKS, kgsBankId } from '../../lib/kgsBanks';

interface Props {
    id?: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}
export const KgsBankSelect: React.FC<Props> = ({ value, onChange, ...props }) => {
    const { t } = usePaymentLanguage();
    const selected = kgsBankId(value) || value;
    return <select {...props} value={selected} onChange={event => onChange(event.target.value)}
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm disabled:opacity-50">
        <option value="" disabled>{t("Выберите банк")}</option>
        {selected && !kgsBankId(selected) && <option value={selected}>{selected} {t("(сохранённый банк)")}</option>}
        {KGS_BANKS.map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}
    </select>;
};
